export default __webpack_public_path__ + "static/game-development-2d55e569bad8bbf32724d096779c44f1.webp";